export default __webpack_public_path__ + "static/media/eleImg_pwd_2_3.855cc4a3.png";